import { render, staticRenderFns } from "./JoinNiceAuthView.vue?vue&type=template&id=0d8fb641&scoped=true&"
import script from "./JoinNiceAuthView.vue?vue&type=script&lang=js&"
export * from "./JoinNiceAuthView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8fb641",
  null
  
)

export default component.exports